module.exports = __webpack_public_path__ + "img/liangcheng.59a27f46.png";